import React from 'react'
import { connect } from 'react-redux'
import Footer from './Footer'
import { bindActionCreators } from 'redux'
import { actions as navigationActions } from '../navigationLinksContainerReducerActions'
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';

class FooterContainer extends React.Component {
  static propTypes = {
    navigationLinks: PropTypes.object,
    navigationLinksFetched: PropTypes.bool.isRequired,
    publicPortalUrl: PropTypes.string.isRequired,
    activeMenu: PropTypes.string,
    setActiveMenu: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.investNow = this.investNow.bind(this)
    this.setActiveMenu = this.setActiveMenu.bind(this)
  }

  investNow () {
    if (this.props.navigationLinksFetched) {
      global.window.location.replace(`${this.props.navigationLinks?.Invest.Link}`)
    }
  }

  setActiveMenu (name) {
    this.props.setActiveMenu(name)
  }

  render () {
    return (
      <Footer
        publicPortalUrl={this.props.publicPortalUrl}
        navigationLinksFetched={this.props.navigationLinksFetched}
        footerMenu={this.props.navigationLinks?.FooterMenu}
        contactPage={this.props.navigationLinks?.ContactPage}
        footerElements={this.props.navigationLinks?.FooterElements}
        legalLinks={this.props.navigationLinks?.LegalLinks}
        investNow={this.investNow}
        activeMenu={this.props.activeMenu}
        setActiveMenu={this.props.setActiveMenu}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    navigationLinks: state.navigationLinksContainer.navigationLinks,
    navigationLinksFetched: state.navigationLinksContainer.navigationLinksFetched,
    publicPortalUrl: state.navigationLinksContainer.publicPortalUrl,
    activeMenu: state.navigationLinksContainer.activeMenu
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setActiveMenu: navigationActions.set.activeMenu
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer)
